import React from 'react';
import { ABILITIES } from '../services/abilityService';

const AbilityPanel = ({
  abilities,
  onUseAbility,
  isMyTurn,
  activeAbility,
  annihilateVertical = false,
  onToggleAnnihilateOrientation
}) => {
  // Convert abilities object to array
  const abilityList = Object.entries(abilities || {})
    .filter(([, data]) => data.active && !data.used)
    .map(([key, data]) => ({
      key,
      name: ABILITIES[key]?.name || key,
      icon: ABILITIES[key]?.icon || '⚡',
      count: data.count || 1,
      ...ABILITIES[key]
    }));

  const handleSelectAbility = (abilityKey) => {
    if (!isMyTurn) return;
    onUseAbility(abilityKey);
  };

  return (
    <div className="h-full bg-gray-900/30 backdrop-blur-sm border-t-2 border-gray-700/50 rounded-t-3xl shadow-2xl flex gap-2 p-3">
      {/* Ability List - 80% */}
      <div className="w-[80%] h-full overflow-x-auto overflow-y-hidden scrollbar-thin scrollbar-thumb-gray-600 scrollbar-track-transparent">
        <div className="flex gap-3 h-full items-center min-w-max">
          {abilityList.length === 0 ? (
            <div className="flex items-center justify-center h-full w-full text-gray-500 text-sm">
              No abilities available
            </div>
          ) : (
            abilityList.map((ability) => (
              <button
                key={ability.key}
                onClick={() => handleSelectAbility(ability.key)}
                disabled={!isMyTurn}
                className={`shrink-0 h-full aspect-square rounded-lg flex flex-col items-center justify-center transition-all relative group
                  ${activeAbility === ability.key
                    ? 'bg-blue-600/50 border-2 border-blue-400/70 scale-105'
                    : 'bg-gray-800/50 border-2 border-gray-600/50 hover:bg-blue-600/30 hover:border-blue-500/50'}
                  ${!isMyTurn ? 'opacity-50 cursor-not-allowed' : 'hover:scale-105 cursor-pointer'}
                `}
              >
                <span className="text-2xl mb-1">{ability.icon}</span>
                <span className="text-[10px] text-gray-400 font-medium">{ability.name}</span>
                {/* Count Badge */}
                <div className="absolute -top-1 -right-1 w-5 h-5 bg-blue-500 rounded-full flex items-center justify-center text-[10px] font-bold border border-gray-900">
                  {ability.count}
                </div>
                {/* Active indicator */}
                {activeAbility === ability.key && (
                  <div className="absolute inset-0 rounded-lg border-2 border-blue-400 animate-pulse"></div>
                )}
              </button>
            ))
          )}
        </div>
      </div>

      {/* Rotation Control - 20% */}
      <div className="w-[20%] h-full bg-gray-800/50 border-2 border-gray-600/50 rounded-lg flex flex-col items-center justify-center gap-1">
        <span className="text-[10px] text-gray-500 uppercase font-semibold">Rotate</span>
        <button
          onClick={onToggleAnnihilateOrientation}
          disabled={activeAbility !== 'ANNIHILATE'}
          className={`w-12 h-12 border rounded flex items-center justify-center transition-all
            ${activeAbility === 'ANNIHILATE'
              ? 'bg-gray-700/50 hover:bg-blue-600/30 border-gray-600/50 hover:border-blue-500/50 hover:scale-110 cursor-pointer'
              : 'bg-gray-800/30 border-gray-700/30 opacity-50 cursor-not-allowed'}
          `}
        >
          <span className={`text-2xl transform ${annihilateVertical ? 'rotate-90' : ''} transition-transform`}>
            ↻
          </span>
        </button>
        {activeAbility === 'ANNIHILATE' && (
          <div className="text-[8px] text-gray-400 text-center">
            {annihilateVertical ? 'Vertical' : 'Horizontal'}
          </div>
        )}
      </div>
    </div>
  );
};

export default AbilityPanel;